import { css } from '@compiled/react';
import { useIntl } from 'react-intl';

import { EmailLetterIcon } from '../email-logos';

const h1Style = css({
	fontSize: '2.25rem',
	fontWeight: '500',
	color: 'rgb(52, 69, 99)',
	fontFamily: `var(--bxp-charlie-display-font-family), sans-serif`,
});
const pStyle = css({
	color: 'rgb(52, 69, 99)',
	textAlign: 'center',
	width: '22rem',
	display: 'inline-flex',
	fontFamily: `var(--bxp-charlie-display-font-family), sans-serif`,
	padding: '2rem 0 0',
	fontSize: '1rem',
});

export const EmailedYou = () => {
	const intl = useIntl();
	const headerMessage = {
		identifier: 'checkemail.header',
		text: intl.formatMessage({
			id: 'checkemail.header.text',
			defaultMessage: 'Verify and activate your account',
		}),
	};

	const weveEmailedYou = {
		identifier: 'checkemail.emailedYou',
		text: intl.formatMessage({
			id: 'checkemail.emailedYou.text',
			defaultMessage:
				"We've emailed your verification link. Verify your account to create your site",
		}),
	};

	return (
		<section>
			<h1 css={h1Style}>{headerMessage.text}</h1>
			<div>
				<EmailLetterIcon />
			</div>
			<p css={pStyle}>{weveEmailedYou.text}</p>
		</section>
	);
};
